<template>
  <tr>
    <td>
      {{tableRowNumber(currentPage, perPage, index)}}
    </td>
    <td class="d-flex align-items-center">
      <div class="mr-2">
        <img :src="artwork.imageThumbUrl" alt="">
      </div>
      <div class="d-flex flex-column">
        {{artwork.catalogNumber}}
        <span v-if="artist">
          {{artist.firstName}} {{artist.lastName}}
        </span>
        <span>{{artwork.name}}</span>
        {{artwork.date}}
      </div>
    </td>
    <td>
      {{I18n.t("price_with_currency", { price: formatNumber(artwork.startingPrice) })}}
    </td>
    <td>
      <span v-if="estimation">
        {{formatNumber(artwork.estimationMin)}} - {{formatNumber(artwork.estimationMax)}} {{I18n.t("artworks.currency")}}
      </span>
    </td>
    <td>
      <span v-if="isUnsold" class="unsold">
        {{ I18n.t("employees.results.auctions_catalogs.artworks.unsold") }}
      </span>
      <span v-else class="sold">
        {{I18n.t("price_with_currency", { price: formatNumber(internetAuction.value) })}}
      </span>
    </td>
    <td>
      <AuctionWinner
        v-if="hasWinner"
        :auction="internetAuction"
      />
    </td>
  </tr>
</template>

<script>
  import { tableRowNumber, formatNumber } from '@/shared/helpers';
  import { UNSOLD_STATE, DEFAULT_PER_PAGE } from './../../../../consts';
  import AuctionWinner from './../../auction_winner';

  /* global Routes */
  export default {
    name: 'FinishedAuctionsCatalogArtworksRow',
    props: {
      artwork: Object,
      index: Number,
      artist: Object,
      internetAuction: Object,
      auctionsCatalog: Object,
      meta: Object,
    },
    components: {
      AuctionWinner,
    },
    created() {
      this.Routes = Routes;
    },
    computed: {
      perPage() {
        return this.meta.per_page || DEFAULT_PER_PAGE;
      },
      currentPage() {
        return this.$route.query.page || 1;
      },
      estimation() {
        return Number.isInteger(this.artwork.estimationMin) && this.artwork.estimationMax;
      },
      isUnsold() {
        return this.internetAuction.state === UNSOLD_STATE;
      },
      hasWinner() {
        return this.internetAuction.winner;
      },
    },
    methods: {
      formatNumber(number) {
        return formatNumber(number);
      },
      tableRowNumber(currentPage, perPage, index) {
        return tableRowNumber(currentPage, perPage, index);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/internet/auctions/row.vue?53056d7e